import { ConstExpression } from "../../Models/ConstExpression";
import { IExpressionEvaluator } from "../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../Models/IExpressionEvaluatorContext";

export class ConstExpressionEvaluator implements IExpressionEvaluator<ConstExpression> {
  get type(): string {
    return "Const";
  }

  evaluate(expression: ConstExpression, context: IExpressionEvaluatorContext): MaybePromise {
    return expression.Value;
  }
}
